module.exports = __webpack_public_path__ + "img/icon_product_2.65687eb7.svg";